<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >SOP Sistem Informasi Pajak Daerah</h6>
    <div class="d-block" style="overflow-x: auto;
	white-space: nowrap;">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="1427"
            style="border-collapse: collapse;table-layout:fixed;width:1072pt"
          >
            <col
              class="xl104"
              width="32"
              style="mso-width-source:userset;mso-width-alt:1170;
 width:24pt"
            />
            <col
              class="xl104"
              width="196"
              style="mso-width-source:userset;mso-width-alt:7168;
 width:147pt"
            />
            <col
              class="xl104"
              width="89"
              style="mso-width-source:userset;mso-width-alt:3254;
 width:67pt"
            />
            <col
              class="xl104"
              width="105"
              style="mso-width-source:userset;mso-width-alt:3840;
 width:79pt"
            />
            <col
              class="xl104"
              width="102"
              style="mso-width-source:userset;mso-width-alt:3730;
 width:77pt"
            />
            <col
              class="xl104"
              width="88"
              span="2"
              style="mso-width-source:userset;mso-width-alt:
 3218;width:66pt"
            />
            <col
              class="xl104"
              width="106"
              style="mso-width-source:userset;mso-width-alt:3876;
 width:80pt"
            />
            <col
              class="xl104"
              width="105"
              style="mso-width-source:userset;mso-width-alt:3840;
 width:79pt"
            />
            <col
              class="xl104"
              width="178"
              style="mso-width-source:userset;mso-width-alt:6509;
 width:134pt"
            />
            <col
              class="xl104"
              width="83"
              style="mso-width-source:userset;mso-width-alt:3035;
 width:62pt"
            />
            <col
              class="xl104"
              width="136"
              style="mso-width-source:userset;mso-width-alt:4973;
 width:102pt"
            />
            <col
              class="xl104"
              width="119"
              style="mso-width-source:userset;mso-width-alt:4352;
 width:89pt"
            />
            <col
              class="xl104"
              width="14"
              style="mso-width-source:userset;mso-width-alt:512;
 width:11pt"
            />
            <tr class="xl104" height="22" style="height:16.5pt">
              <td
                height="22"
                class="xl102"
                colspan="9"
                width="911"
                style="height:16.5pt;
  mso-ignore:colspan;width:685pt"
              >
                <a name="Print_Area">
                  Prosedur Pelayanan
                  Penetapan Pajak Daerah dengan Cara Penetapan Kepala Daerah (
                  <font class="font34">Official Assessment</font>
                  <font class="font12">)</font>
                </a>
              </td>
              <td class="xl103" width="178" style="width:134pt"></td>
              <td class="xl103" width="83" style="width:62pt"></td>
              <td class="xl103" width="136" style="width:102pt"></td>
              <td class="xl103" width="119" style="width:89pt"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="28" style="mso-height-source:userset;height:21.0pt">
              <td
                rowspan="3"
                height="128"
                class="xl314"
                style="border-bottom:.5pt solid black;
  height:96.0pt"
              >No</td>
              <td rowspan="3" class="xl107" style="border-bottom:.5pt solid black">Uraian</td>
              <td colspan="7" class="xl118" style="border-left:none">&nbsp;</td>
              <td
                colspan="3"
                class="xl317"
                style="border-right:.5pt solid black;border-left:
  none"
              >Mutu Baku</td>
              <td rowspan="3" class="xl107" style="border-bottom:.5pt solid black">Ket</td>
            </tr>
            <tr height="20" style="mso-height-source:userset;height:15.0pt">
              <td
                rowspan="2"
                height="100"
                class="xl308"
                width="89"
                style="border-bottom:.5pt solid black;
  height:75.0pt;width:67pt"
              >Kepala Bapenda</td>
              <td
                rowspan="2"
                class="xl306"
                width="105"
                style="border-bottom:.5pt solid black;
  border-top:none;width:79pt"
              >Sekretaris</td>
              <td
                rowspan="2"
                class="xl306"
                width="102"
                style="border-bottom:.5pt solid black;
  border-top:none;width:77pt"
              >Kepala Bidang Pengelolaan Penerimaan Daerah</td>
              <td
                rowspan="2"
                class="xl308"
                width="88"
                style="border-bottom:.5pt solid black;
  width:66pt"
              >Kasubbid Verifikasi dan Penetapan</td>
              <td
                rowspan="2"
                class="xl306"
                width="88"
                style="border-bottom:.5pt solid black;
  border-top:none;width:66pt"
              >Kasubbid Pendaftaran dan Pendataaan</td>
              <td
                rowspan="2"
                class="xl308"
                width="106"
                style="border-bottom:.5pt solid black;
  width:80pt"
              >Jabatan Fungsional Umum</td>
              <td rowspan="2" class="xl305" style="border-bottom:.5pt solid black">Wajib Pajak</td>
              <td
                rowspan="2"
                class="xl107"
                style="border-bottom:.5pt solid black;border-top:
  none"
              >Persyaratan/Kelengkapan</td>
              <td
                rowspan="2"
                class="xl107"
                style="border-bottom:.5pt solid black;border-top:
  none"
              >Waktu</td>
              <td
                rowspan="2"
                class="xl309"
                style="border-bottom:.5pt solid black;border-top:
  none"
              >Output</td>
            </tr>
            <tr height="80" style="mso-height-source:userset;height:60.0pt"></tr>
            <tr height="162" style="mso-height-source:userset;height:121.5pt">
              <td height="162" class="xl118" style="height:121.5pt;border-top:none">1</td>
              <td class="xl105" width="196" style="border-top:none;border-left:none;width:147pt">
                Subbidang
                Pendaftaran dan Pendataan melaksanakan pendataan objek pajak daerah
                menggunakan alat ukur penetapan.
              </td>
              <td align="left" valign="top">
                <!--[if gte vml 1]><v:shapetype id="_x0000_t75"
   coordsize="21600,21600" o:spt="75" o:preferrelative="t" path="m@4@5l@4@11@9@11@9@5xe"
   filled="f" stroked="f">
   <v:stroke joinstyle="miter"/>
   <v:formulas>
    <v:f eqn="if lineDrawn pixelLineWidth 0"/>
    <v:f eqn="sum @0 1 0"/>
    <v:f eqn="sum 0 0 @1"/>
    <v:f eqn="prod @2 1 2"/>
    <v:f eqn="prod @3 21600 pixelWidth"/>
    <v:f eqn="prod @3 21600 pixelHeight"/>
    <v:f eqn="sum @0 0 1"/>
    <v:f eqn="prod @6 1 2"/>
    <v:f eqn="prod @7 21600 pixelWidth"/>
    <v:f eqn="sum @8 21600 0"/>
    <v:f eqn="prod @7 21600 pixelHeight"/>
    <v:f eqn="sum @10 21600 0"/>
   </v:formulas>
   <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
   <o:lock v:ext="edit" aspectratio="t"/>
  </v:shapetype><v:shape id="Diamond_x0020_1" o:spid="_x0000_s20481" type="#_x0000_t75"
   style='position:absolute;margin-left:295.5pt;margin-top:45.75pt;width:45.75pt;
   height:26.25pt;z-index:1;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image022.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rounded_x0020_Rectangle_x0020_6" o:spid="_x0000_s20482"
   type="#_x0000_t75" style='position:absolute;margin-left:448.5pt;
   margin-top:657pt;width:52.5pt;height:24.75pt;z-index:2;visibility:visible;
   mso-wrap-style:square;v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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=
" o:insetmode="auto">
   <v:imagedata src="image249.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_11" o:spid="_x0000_s20483" type="#_x0000_t75"
   style='position:absolute;margin-left:452.25pt;margin-top:266.25pt;width:45.75pt;
   height:39pt;z-index:3;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image250.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_15" o:spid="_x0000_s20484" type="#_x0000_t75"
   style='position:absolute;margin-left:236.25pt;margin-top:381pt;width:39pt;
   height:21.75pt;z-index:4;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH
74LvEOYqbaoHEWm6B6tHFV0fYEimbdg2CZlYd9/edD8u4goeZ+b/8SOpV9tpFDNFtt4puC4rEOS0
N9b1Cj7WT8UdCE7oDI7ekYIdMayay4t6vQvEIrsdKxhSCvdSsh5oQi59IJcvnY8TpjzGXgbUG+xJ
3lTVrdTeJXKpSEsGNHVLHX6OSTxu8/pAEmlkEA8H4dKlAEMYrcaUSeXszI+W4thQZudew4MNfJUx
QP7asFzOFxx9L/lpojUkXjGmZ5wyhjSRJQ8YKGvKv1MWzIkL33VWU9lGfl98J6hz4cZ/uUjzf7Pb
bHuj+ZQu9z/UfAMAAP//AwBQSwMEFAAGAAgAAAAhADHdX2HSAAAAjwEAAAsAAABfcmVscy8ucmVs
c6SQwWrDMAyG74O9g9G9cdpDGaNOb4VeSwe7CltJTGPLWCZt376mMFhGbzvqF/o+8e/2tzCpmbJ4
jgbWTQuKomXn42Dg63xYfYCSgtHhxJEM3Elg372/7U40YalHMvokqlKiGBhLSZ9aix0poDScKNZN
zzlgqWMedEJ7wYH0pm23Ov9mQLdgqqMzkI9uA+p8T9X8hx28zSzcl8Zy0Nz33r6iasfXeKK5UjAP
VAy4LM8w09zU50C/9q7/6ZURE31X/kL8TKv1x6wXNXYPAAAA//8DAFBLAwQUAAYACAAAACEA5gjZ
OIoCAACVBwAAEAAAAGRycy9zaGFwZXhtbC54bWysld1umzAUx+8n7R0s37dAAoSgmGpL1d1MW5S0
D+CBSdCMjWwrIW+/YxtoJ22TVpKbGB/7/H/nw/bmoW85OjOlGykIju5DjJgoZdWII8Evz093GUba
UFFRLgUj+Mo0fig+ftj0lcqpKE9SIXAhdA4TBJ+M6fIg0OWJtVTfy44JsNZStdTApzoGlaIXcN7y
YBGGaaA7xWilT4yZR2/BhfNtLnLLOP/kJPxUrWTrR6XkRbIJLIMdug0w+F7XRbQO4/V6stkpZ1by
UmR+2g7HOWtfLuL1Kppsbovz/Spo5CTyN+F0FYer9L+EkyxdhwMrQL0Kj3K6Qy0tlSQYI8N6wxvx
E8aeRZwP3U4NXN/OO4WaCkqYYiRoC6XasxIKd+QMRQkOpnV2E3y5AN+60M4ZzftatUNJ6TsK2tJG
ACDNZV2jnuAkjBdpDFBXgtM4yxZhamFoDuGgEhbE2TJZrTAqYcEijdbLzNoDD2IXdkqbL0zOhkLW
EcEK0uIA6fmrNl5qlLByQj41nM/NgAuRi7lu0IXgZbRKHLCWvKksnMXUV73lCp0pJxgOVCUvz5BR
jDjVBgwEh+435PLNVsgsF0P9fc3tMdLmypn1y8WeQeHckX53/aETobILT23vAjax0rJkwkTedKIV
8yEklnaEHXe4NnBAlqyGyG/GNgCMSh5iZPNNMehZaVbX0DU3Ew//lRgvPim6yKW4nXjbCKn+BMCh
KkPkXm9sEt8atktM/1lWV4v0A/7hxpnbJ8rwrYQOhmfHPyYEl0ZZDOhEbQ5Weq6Ic9bN9eLaQFQ7
qugeAudwsxLMxN3LYUhaN6RrzJG7YDXMuleKN9D1j9RQm2GXyt/fNzfnU1D8AgAA//8DAFBLAwQU
AAYACAAAACEA+zBT3yMBAACcAQAADwAAAGRycy9kb3ducmV2LnhtbHxQ30/CMBh8N/F/aD4TX4x0
/NhgSEfQhEh8IAGRxLeytdvi2mLbseFf70fQ4JOPd/fd9a6TaasqchDWlUYz6HYCIEKnJit1zmDz
Or8fAXGe64xXRgsGR+FgmlxfTfg4M41eicPa5wRDtBtzBoX3+zGlLi2E4q5j9kKjJo1V3CO0Oc0s
bzBcVbQXBBFVvNT4QsH34qkQ6ce6Vgze7upB/S6DzbJ9qbfx4zzf7j4bxm5v2tkDEC9afzn+cS8y
rB8Bkc/HnS2zFXdeWAa4B9ehBAlWbquZTgtjiVwJV37hnjMvrVHEmoYBzk1NxSCEE15K6YRn0O8O
+j2kUPqluqMgHoZAT7He/GcO4yAMsccfczSMemczvZRKJggun5p8AwAA//8DAFBLAQItABQABgAI
AAAAIQDw94q7/QAAAOIBAAATAAAAAAAAAAAAAAAAAAAAAABbQ29udGVudF9UeXBlc10ueG1sUEsB
Ai0AFAAGAAgAAAAhADHdX2HSAAAAjwEAAAsAAAAAAAAAAAAAAAAALgEAAF9yZWxzLy5yZWxzUEsB
Ai0AFAAGAAgAAAAhAOYI2TiKAgAAlQcAABAAAAAAAAAAAAAAAAAAKQIAAGRycy9zaGFwZXhtbC54
bWxQSwECLQAUAAYACAAAACEA+zBT3yMBAACcAQAADwAAAAAAAAAAAAAAAADhBAAAZHJzL2Rvd25y
ZXYueG1sUEsFBgAAAAAEAAQA9QAAADEGAAAAAA==
" o:insetmode="auto">
   <v:imagedata src="image004.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_18" o:spid="_x0000_s20485" type="#_x0000_t75"
   style='position:absolute;margin-left:297pt;margin-top:160.5pt;width:45pt;
   height:38.25pt;z-index:5;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image251.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_27" o:spid="_x0000_s20486"
   type="#_x0000_t75" style='position:absolute;margin-left:318.75pt;
   margin-top:198pt;width:140.25pt;height:94.5pt;z-index:6;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH
7ya+A+FqWqoHY0zpHqwe1Zj1AQhMW2I7EAbr7ts73e5ejGviEeb/8RuoN7tpFDMk8gG1vC4rKQBt
cB57Ld+3T8WdFJQNOjMGBC33QHLTXF7U230EEuxG0nLIOd4rRXaAyVAZIiBPupAmk/mYehWN/TA9
qJuqulU2YAbMRV4yZFO30JnPMYvHHV+vJAlGkuJhFS5dWpoYR29NZlI1o/vRUhwbSnYeNDT4SFeM
IdWvDcvkfMHR98JPk7wD8WpSfjYTYyiXaNkAweaQWFf+nbSgTlSErvMWyjYRL7V6T3DnSlz4wgTz
f/Nbtr3BfEpXh59qvgEAAP//AwBQSwMEFAAGAAgAAAAhAJYFM1jUAAAAlwEAAAsAAABfcmVscy8u
cmVsc6SQPWsDMQyG90L/g9He8yVDKSW+bIWsIYWuxtZ9kLNkJHNN/n1MoaVXsnWUXvQ8L9rtL2k2
C4pOTA42TQsGKXCcaHDwfnp7egGjxVP0MxM6uKLCvnt82B1x9qUe6ThlNZVC6mAsJb9aq2HE5LXh
jFSTniX5UkcZbPbh7Ae027Z9tvKbAd2KaQ7RgRziFszpmqv5DztNQVi5L03gZLnvp3CPaiN/0hGX
SvEyYHEQRb+WgktTy4G979380xuYCENh+aiOlfwnqfbvBnb1zu4GAAD//wMAUEsDBBQABgAIAAAA
IQCpaKd3QwIAAKkGAAAUAAAAZHJzL2Nvbm5lY3RvcnhtbC54bWy8lc2O2yAQx++V+g6Ie9eGJI5j
xV5V2W17qLarfjwAa0NiFYMFKHHevgPYjrqqemii5hI84/n/mA/w9n7oJDpyY1utSkzuUoy4qnXT
qn2Jf3z/8C7HyDqmGia14iU+c4vvq7dvtkNjCqbqgzYIJJQtwFDig3N9kSS2PvCO2TvdcwVeoU3H
HDyafdIYdgLxTiY0TbPE9oazxh44dw/Rg6ug7U56x6V8HxDRJIzu4qrWssq2id+DX4YAWHwRolqm
lBI6+7wpuI0+TSF+Odm8f7NebgiJIeALIUH7AnR6hlT5LD7bfAhdkdWkMu5lglTrWfw3cL5aELKc
fRfwjBvUtx51rDa6xGNh1HHnrc9mpD8dnw1qmxJTaJViHTTpUb7oE9pppXjtoEF0jZP57TmaFdbB
w9g+9g/N61ircGCTjf8fYBOexAqumptJ01GaeOnY86dLDYLhVU1sqA4rBmG6q9Mz2sHByGBa4YeR
kG3/CQzQDVZoIRAknS1yuknXGJ1LvMhXeZptxjIMDtXwAiGUpqsMoxreINkmp+s0ZBP36KV6Y91H
rq/frxcq8QtXbh4AGjbLjp+t8yW8wDxYXj0BXsWxVj6qBrlzDwPoTMvUXvIxR6nGxsXG+GNr3Vny
iP/KoYjhCrlmBn2VQ5rh7uE7adCRyRI3P+Pc+ESB5JGilfJm0PTv0JHlsVwIOI7/CzzTQsZa3Q7c
tUqbP2XthqnUIvKmrsdex6Pr767xLpItDOkDc2w616/u/BAQvzHVLwAAAP//AwBQSwMEFAAGAAgA
AAAhALUko+AVAQAAigEAAA8AAABkcnMvZG93bnJldi54bWxckMtuwjAQRfeV+g/WVOquOCQNr2IQ
QirqChVK91YyJoHYBtuQtF/f4VFRdWXdGZ87d2Y4bnTFjuh8aY2AdisChiazeWnWAlYfr089YD5I
k8vKGhTwhR7Go/u7oRzktjYLPC7DmpGJ8QMpoAhhN+DcZwVq6Vt2h4Z6yjotA0m35rmTNZnrisdR
1OFaloYmFHKH0wKz7fKgBdT9FT/I+X6Dne2ne5+q2V5tZkI8PjSTF2ABm3D7fKXfcgExhaVdaA8Y
UcCmmpissI6pBfrym9Jf6spZzZytBXSAZbY6v6TnSnkMAvrddprSIaj1W0r6URqnwE+2wV7g7hWm
oX/hJHn+D8dJj0oE81uos7idcPQDAAD//wMAUEsBAi0AFAAGAAgAAAAhAP4l66UAAQAA6gEAABMA
AAAAAAAAAAAAAAAAAAAAAFtDb250ZW50X1R5cGVzXS54bWxQSwECLQAUAAYACAAAACEAlgUzWNQA
AACXAQAACwAAAAAAAAAAAAAAAAAxAQAAX3JlbHMvLnJlbHNQSwECLQAUAAYACAAAACEAqWind0MC
AACpBgAAFAAAAAAAAAAAAAAAAAAuAgAAZHJzL2Nvbm5lY3RvcnhtbC54bWxQSwECLQAUAAYACAAA
ACEAtSSj4BUBAACKAQAADwAAAAAAAAAAAAAAAACjBAAAZHJzL2Rvd25yZXYueG1sUEsFBgAAAAAE
AAQA+QAAAOUFAAAAAA==
">
   <v:imagedata src="image252.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_33" o:spid="_x0000_s20487"
   type="#_x0000_t75" style='position:absolute;margin-left:313.5pt;
   margin-top:70.5pt;width:12pt;height:96.75pt;z-index:7;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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==
">
   <v:imagedata src="image253.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_34" o:spid="_x0000_s20488"
   type="#_x0000_t75" style='position:absolute;margin-left:268.5pt;
   margin-top:304.5pt;width:207.75pt;height:93.75pt;z-index:8;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image254.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_37" o:spid="_x0000_s20489" type="#_x0000_t75"
   style='position:absolute;margin-left:159.75pt;margin-top:463.5pt;width:45pt;
   height:39pt;z-index:9;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image255.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Diamond_x0020_38" o:spid="_x0000_s20490" type="#_x0000_t75"
   style='position:absolute;margin-left:75.75pt;margin-top:463.5pt;width:45.75pt;
   height:39pt;z-index:10;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image250.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_39" o:spid="_x0000_s20491"
   type="#_x0000_t75" style='position:absolute;margin-left:198pt;margin-top:402pt;
   width:57.75pt;height:87.75pt;z-index:11;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image256.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_42" o:spid="_x0000_s20492"
   type="#_x0000_t75" style='position:absolute;margin-left:181.5pt;
   margin-top:385.5pt;width:60.75pt;height:79.5pt;z-index:12;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image257.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_45" o:spid="_x0000_s20493"
   type="#_x0000_t75" style='position:absolute;margin-left:99pt;margin-top:495.75pt;
   width:90pt;height:24pt;z-index:13;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image258.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_53" o:spid="_x0000_s20494"
   type="#_x0000_t75" style='position:absolute;margin-left:114pt;margin-top:477pt;
   width:46.5pt;height:12.75pt;z-index:14;visibility:visible' o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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=
">
   <v:imagedata src="image259.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_55" o:spid="_x0000_s20495"
   type="#_x0000_t75" style='position:absolute;margin-left:23.25pt;
   margin-top:483pt;width:53.25pt;height:89.25pt;z-index:15;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image260.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_57" o:spid="_x0000_s20496" type="#_x0000_t75"
   style='position:absolute;margin-left:11.25pt;margin-top:565.5pt;width:38.25pt;
   height:21pt;z-index:16;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH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" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Straight_x0020_Arrow_x0020_Connector_x0020_60" o:spid="_x0000_s20497"
   type="#_x0000_t75" style='position:absolute;margin-left:48.75pt;
   margin-top:569.25pt;width:339pt;height:12.75pt;z-index:17;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image261.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Rectangle_x0020_61" o:spid="_x0000_s20498" type="#_x0000_t75"
   style='position:absolute;margin-left:381.75pt;margin-top:564.75pt;width:38.25pt;
   height:21pt;z-index:18;visibility:visible;mso-wrap-style:square;
   v-text-anchor:top' o:gfxdata="UEsDBBQABgAIAAAAIQDw94q7/QAAAOIBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzUrEMBDH
74LvEOYqbaoHEWm6B6tHFV0fYEimbdg2CZlYd9/edD8u4goeZ+b/8SOpV9tpFDNFtt4puC4rEOS0
N9b1Cj7WT8UdCE7oDI7ekYIdMayay4t6vQvEIrsdKxhSCvdSsh5oQi59IJcvnY8TpjzGXgbUG+xJ
3lTVrdTeJXKpSEsGNHVLHX6OSTxu8/pAEmlkEA8H4dKlAEMYrcaUSeXszI+W4thQZudew4MNfJUx
QP7asFzOFxx9L/lpojUkXjGmZ5wyhjSRJQ8YKGvKv1MWzIkL33VWU9lGfl98J6hz4cZ/uUjzf7Pb
bHuj+ZQu9z/UfAMAAP//AwBQSwMEFAAGAAgAAAAhADHdX2HSAAAAjwEAAAsAAABfcmVscy8ucmVs
c6SQwWrDMAyG74O9g9G9cdpDGaNOb4VeSwe7CltJTGPLWCZt376mMFhGbzvqF/o+8e/2tzCpmbJ4
jgbWTQuKomXn42Dg63xYfYCSgtHhxJEM3Elg372/7U40YalHMvokqlKiGBhLSZ9aix0poDScKNZN
zzlgqWMedEJ7wYH0pm23Ov9mQLdgqqMzkI9uA+p8T9X8hx28zSzcl8Zy0Nz33r6iasfXeKK5UjAP
VAy4LM8w09zU50C/9q7/6ZURE31X/kL8TKv1x6wXNXYPAAAA//8DAFBLAwQUAAYACAAAACEAph7U
iY4CAACXBwAAEAAAAGRycy9zaGFwZXhtbC54bWysVcuO2yAU3VfqPyD2M34lfil41GY03VRtlMx8
ALVxYhWDBSiPv+8F7MxU6nQxTjbBXLjn3HMPsHo49xwdmdKdFARH9yFGTNSy6cSe4Jfnp7scI22o
aCiXghF8YRo/VJ8/rc6NKqmoD1IhSCF0CRMEH4wZyiDQ9YH1VN/LgQmItlL11MCn2geNoidI3vMg
DsM00INitNEHxsyjj+DK5TYnuWacf3EQfqpVsvejWvIqWwWWgx26DTD42bZVssiSPL7G7JQLK3mq
otDP2/E0aRcskiyMi2vM7XHJXxGNvKK8h5wnYbEcs4xkJpB3kdMiL9KxEmD1ijzh6QH1tFaSYIwM
Oxveid8w9mTEcTds1Ejsx3GjUNcQnMYYCdpDs7ashtbtOUNphIPrOrsJvlyFb1Nol4yW51b1Y1Pp
B1ra004AQVrKtkVngkHbNMzBRxeC8zwqQGpLhpZQDqphwSJPllmGUQ0L4jQqktzGA0/ELhyUNt+Y
nE0K2UQEK5DFEaTH79p4qAnCwgn51HE+VwFXIhdz06ATwUmULR1hLXnXWHKWpr7oNVfoSDnBcKQa
eXoGRTHiVBsIEBy636jlm62gLBdj/33P7UHS5sKZzcvFlkHj3KH+cP/BidDZ2LO2twG7cqV1zYSJ
fOhAG+ZLWFq2E9lph7OBI2SZtVD5zbiNBCYkT2Li5k0x4llo1rbgmpuBh/8TxoNfEV3lUtwOvO+E
VP8iwKErY+UebzKJt4Z1iTl/lc3FUvoF/3DjzPWJMnwtwcHw8PjnhODaKEsDnKjNzkLPBXHJhrlZ
nA1Es6GKbqFwDjcrwUzcvexG0YZRrkkjd8FqmHXvFO/A9Y/UUKuwk/LvF87NeQmqPwAAAP//AwBQ
SwMEFAAGAAgAAAAhAJJCzLseAQAAngEAAA8AAABkcnMvZG93bnJldi54bWx8kM1OwzAQhO9IvIO1
SNyo0zQJodSpKlBVikSlFMTZJJsfEduVbdqUp2dbQJU4cJzZ/cY7nkx71bEtWtcaLWA4CIChLkzZ
6lrAy/P8KgXmvNSl7IxGAXt0MM3OzyZyXJqdznG79jWjEO3GUkDj/WbMuSsaVNINzAY1zSpjlfQk
bc1LK3cUrjoeBkHClWw1vdDIDd41WLyvP5SA5SKIXuP8aXs/583qkbtoOcyNEJcX/ewWmMfen5Z/
6IdSQBICqxb7N9uWuXQerQDqQ+2oGWR0ct/NdNEYy6ocXftJfb79yhrFrNmRJqAwnYBrOBirqnLo
BURhmoTxcfRrjeIwIosfcr35l05u4tEfOh2l1P9A89NZR3H61uwLAAD//wMAUEsBAi0AFAAGAAgA
AAAhAPD3irv9AAAA4gEAABMAAAAAAAAAAAAAAAAAAAAAAFtDb250ZW50X1R5cGVzXS54bWxQSwEC
LQAUAAYACAAAACEAMd1fYdIAAACPAQAACwAAAAAAAAAAAAAAAAAuAQAAX3JlbHMvLnJlbHNQSwEC
LQAUAAYACAAAACEAph7UiY4CAACXBwAAEAAAAAAAAAAAAAAAAAApAgAAZHJzL3NoYXBleG1sLnht
bFBLAQItABQABgAIAAAAIQCSQsy7HgEAAJ4BAAAPAAAAAAAAAAAAAAAAAOUEAABkcnMvZG93bnJl
di54bWxQSwUGAAAAAAQABAD1AAAAMAYAAAAA
" o:insetmode="auto">
   <v:imagedata src="image007.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><v:shape id="Elbow_x0020_Connector_x0020_63" o:spid="_x0000_s20499"
   type="#_x0000_t75" style='position:absolute;margin-left:400.5pt;
   margin-top:585pt;width:54.75pt;height:89.25pt;z-index:19;visibility:visible'
   o:gfxdata="UEsDBBQABgAIAAAAIQD+JeulAAEAAOoBAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbJSRzU7EIBDH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">
   <v:imagedata src="image262.png" o:title=""/>
   <o:lock v:ext="edit" aspectratio="f"/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
                </v:shape><![endif]-->

                <span
                  style="mso-ignore:vglayout;
  position:absolute;z-index:1;margin-left:15px;margin-top:61px;width:653px;
  height:848px"
                >
                  <img
                    width="653"
                    height="848"
                    src="/img/image263.png"
                    v:shapes="Diamond_x0020_1 Rounded_x0020_Rectangle_x0020_6 Diamond_x0020_11 Rectangle_x0020_15 Diamond_x0020_18 Elbow_x0020_Connector_x0020_27 Straight_x0020_Arrow_x0020_Connector_x0020_33 Elbow_x0020_Connector_x0020_34 Diamond_x0020_37 Diamond_x0020_38 Elbow_x0020_Connector_x0020_39 Elbow_x0020_Connector_x0020_42 Elbow_x0020_Connector_x0020_45 Straight_x0020_Arrow_x0020_Connector_x0020_53 Elbow_x0020_Connector_x0020_55 Rectangle_x0020_57 Straight_x0020_Arrow_x0020_Connector_x0020_60 Rectangle_x0020_61 Elbow_x0020_Connector_x0020_63"
                  />
                </span>
                <span style="mso-ignore:vglayout2">
                  <table cellpadding="0" cellspacing="0">
                    <tr>
                      <td
                        height="162"
                        class="xl106"
                        width="89"
                        style="height:121.5pt;border-top:none;
    border-left:none;width:67pt"
                      >&nbsp;</td>
                    </tr>
                  </table>
                </span>
              </td>
              <td class="xl106" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl106" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl106" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl106" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl107" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl106" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl145" width="178" style="border-top:none;border-left:none;width:134pt">
                Laporan
                hasil pendataan objek pajak reklame dan air tanah
              </td>
              <td class="xl146" width="83" style="border-top:none;border-left:none;width:62pt">
                15
                Hari Kerja
              </td>
              <td class="xl145" width="136" style="border-top:none;border-left:none;width:102pt">
                Laporan
                hasil pendataan objek pajak reklame dan air tanah
              </td>
              <td
                class="xl110"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="130" style="mso-height-source:userset;height:97.5pt">
              <td height="130" class="xl115" style="height:97.5pt;border-top:none">2</td>
              <td class="xl116" width="196" style="border-left:none;width:147pt">
                Menghitung
                dasar pengenaan pajak
                <span style="mso-spacerun:yes">�</span>secara jabatan
                berdasarkan hasil laporan pendataan Subbidang Pendaftaran dan Pendataan.
              </td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl117" style="border-left:none">&nbsp;</td>
              <td class="xl118" style="border-left:none">&nbsp;</td>
              <td class="xl145" width="178" style="border-left:none;width:134pt">
                Laporan hasil
                pendataan objek pajak reklame dan air tanah
              </td>
              <td class="xl235" width="83" style="border-left:none;width:62pt">10 Menit</td>
              <td class="xl145" width="136" style="border-left:none;width:102pt">
                Laporan hasil
                pendataan objek pajak reklame dan air tanah
              </td>
              <td class="xl119" width="119" style="border-left:none;width:89pt">&nbsp;</td>
            </tr>
            <tr height="183" style="mso-height-source:userset;height:137.25pt">
              <td height="183" class="xl118" style="height:137.25pt;border-top:none">3</td>
              <td class="xl116" width="196" style="border-top:none;border-left:none;width:147pt">
                Melakukan
                rekonsiliasi / konfirmasi atas hasil pengukuran dasar pengenaan pajak yang
                akan ditetapkan, apabila wajib pajak setuju, maka dilakukan pendataan bersama
                dilapangan.
              </td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl155" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl155" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl236" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl118" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl145" width="178" style="border-left:none;width:134pt">
                Laporan hasil
                pendataan objek pajak reklame dan air tanah
              </td>
              <td
                class="xl235"
                width="83"
                style="border-top:none;border-left:none;width:62pt"
              >&nbsp;</td>
              <td class="xl145" width="136" style="border-left:none;width:102pt">
                Laporan hasil
                pendataan objek pajak reklame dan air tanah atau laporan hasil rekonsiliasi
                apabila wajib pajak tidak setuju dengan laporan hasil pendataan Bapenda.
              </td>
              <td
                class="xl119"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="109" style="mso-height-source:userset;height:81.75pt">
              <td height="109" class="xl115" style="height:81.75pt;border-top:none">4</td>
              <td class="xl116" width="196" style="border-top:none;border-left:none;width:147pt">
                Menghitung
                besarnya pajak terutang dan membuat surat ketetapan pajak daerah (SKPD) untuk
                ditetapkan oleh Kepala Bapenda.
              </td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl237" style="border-top:none;border-left:none">Tidak</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl118" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl145" width="178" style="border-left:none;width:134pt">
                Laporan hasil
                pendataan objek pajak reklame dan air tanah atau laporan hasil rekonsiliasi
                apabila wajib pajak tidak setuju dengan laporan hasil pendataan Bapenda.
              </td>
              <td class="xl235" width="83" style="border-top:none;border-left:none;width:62pt">
                15
                Menit
              </td>
              <td class="xl147" width="136" style="border-left:none;width:102pt">Konsep SKPD</td>
              <td
                class="xl119"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="124" style="mso-height-source:userset;height:93.0pt">
              <td height="124" class="xl118" style="height:93.0pt;border-top:none">5</td>
              <td class="xl116" width="196" style="border-top:none;border-left:none;width:147pt">
                Melaksanakan
                pemeriksaan kelengkapan konsep SKPD. Apabila lengkap maka di parap dan
                disampaikan ke Kepala Badan.
              </td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl238" style="border-top:none;border-left:none">Tidak</td>
              <td class="xl239" style="border-top:none;border-left:none">Ya</td>
              <td class="xl117" style="border-top:none;border-left:none">Ya</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl118" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl147" width="178" style="border-left:none;width:134pt">Konsep SKPD</td>
              <td class="xl235" width="83" style="border-top:none;border-left:none;width:62pt">
                5
                Menit
              </td>
              <td
                class="xl147"
                width="136"
                style="border-top:none;border-left:none;width:102pt"
              >SKPD</td>
              <td
                class="xl119"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="124" style="mso-height-source:userset;height:93.0pt">
              <td height="124" class="xl115" style="height:93.0pt;border-top:none">6</td>
              <td class="xl116" width="196" style="border-top:none;border-left:none;width:147pt">
                Menandatangani
                SKPD sebagai dasar penetapan nilai pajak terutang kemudian disampaikan ke
                wajib pajak.
              </td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl118" style="border-top:none;border-left:none">&nbsp;</td>
              <td
                class="xl147"
                width="178"
                style="border-top:none;border-left:none;width:134pt"
              >SKPD</td>
              <td class="xl235" width="83" style="border-top:none;border-left:none;width:62pt">
                5
                Menit
              </td>
              <td
                class="xl147"
                width="136"
                style="border-top:none;border-left:none;width:102pt"
              >SKPD</td>
              <td
                class="xl119"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="124" style="mso-height-source:userset;height:93.0pt">
              <td height="124" class="xl118" style="height:93.0pt;border-top:none">7</td>
              <td class="xl116" width="196" style="border-top:none;border-left:none;width:147pt">
                Wajib
                pajak melakukan pembayaran pajak terutang menggunakan SSPD melalui bank yang
                telah ditunjuk.
              </td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl117" style="border-top:none;border-left:none">&nbsp;</td>
              <td class="xl118" style="border-top:none;border-left:none">&nbsp;</td>
              <td
                class="xl147"
                width="178"
                style="border-top:none;border-left:none;width:134pt"
              >SKPD</td>
              <td class="xl235" width="83" style="border-top:none;border-left:none;width:62pt">
                5
                Menit
              </td>
              <td class="xl147" width="136" style="border-top:none;border-left:none;width:102pt">STS</td>
              <td
                class="xl119"
                width="119"
                style="border-top:none;border-left:none;width:89pt"
              >&nbsp;</td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl126" style="height:15.0pt"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl126"></td>
              <td class="xl104"></td>
              <td class="xl128"></td>
              <td class="xl129"></td>
              <td class="xl129"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl126" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl128"></td>
              <td class="xl130"></td>
              <td class="xl130"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl131"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl131"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl132"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl128"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="20" style="height:15.0pt">
              <td height="20" class="xl104" style="height:15.0pt"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
              <td class="xl128"></td>
              <td class="xl104"></td>
              <td class="xl104"></td>
            </tr>
            <tr height="0" style="display:none">
              <td width="32" style="width:24pt"></td>
              <td width="196" style="width:147pt"></td>
              <td width="89" style="width:67pt"></td>
              <td width="105" style="width:79pt"></td>
              <td width="102" style="width:77pt"></td>
              <td width="88" style="width:66pt"></td>
              <td width="88" style="width:66pt"></td>
              <td width="106" style="width:80pt"></td>
              <td width="105" style="width:79pt"></td>
              <td width="178" style="width:134pt"></td>
              <td width="83" style="width:62pt"></td>
              <td width="136" style="width:102pt"></td>
              <td width="119" style="width:89pt"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    Modal,
    PulseLoader,
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      htmls: null,
      isBusy: false,
    };
  },
  methods: {
    showModal() {
      this.modals.modal1 = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 1000px;
  margin: 1.75rem auto;
}

</style>